
/**
 * 상세 에러 정보 (선택적)
 * @nullable
 */
export type UpdateConversation404Details = { [key: string]: unknown } | null;
